import Vue from "vue";
import Router from "vue-router";
import LoginPage from "@/views/LoginPage";
import LandingPage from "@/views/LandingPage";
import HealthpointLevel from "@/views/-HealthpointLevel";
import DashboardByGroup from "@/views/DashboardByGroup";
import GroupView from "@/views/GroupView";
import GroupForm from "@/views/GroupForm";
import MemberView from "@/views/MemberView";
import ChallengePage from "@/views/ChallengePage";
import ChallengeGroupList from "@/views/ChallengeGroupList";
import ChallengeUserList from "@/views/ChallengeUserList";
import ChallengeUserDetail from "@/views/ChallengeUserDetail";
import ChallengeAdminManagement from "@/views/ChallengeAdminManagement";
import ChallengeAdminManagementForm from "@/views/ChallengeAdminManagementForm";
import ChallengeGroupListVerify from "@/views/ChallengeGroupListVerify";
import ChallengeSummary from "@/views/ChallengeSummary";
import ChallengeForm from "@/views/ChallengeForm";
import QuizManagementList from "@/views/QuizManagementList";
import QuizManagementForm from "@/views/QuizManagementForm";
import OrgManagementList from "@/views/OrgManagementList";
import OrgManagementForm from "@/views/OrgManagementForm";
import OrgManagementCoachList from "@/views/OrgManagementCoachList";
import ProgramManagement from "@/views/ProgramManagement";
import ProgramManagementForm from "@/views/ProgramManagementForm";
import ProgramManagementList from "@/views/ProgramManagementList";
import ProgramViewMemberList from "@/views/ProgramViewMemberList";
import ProgramManagementCoachForm from "@/views/ProgramManagementCoachForm"
import ProgramManagementMemberForm from "@/views/ProgramManagementMemberForm";
import BloodTestsList from "@/views/BloodTestsList";
import BloodTestsForm from "@/views/BloodTestsForm";
import BodyList from "@/views/BodyList";
import LineCallback from "@/views/LineCallback";
import BodyForm from "@/views/BodyForm";
import ProgramManagementMember from "@/views/ProgramManagementMember";
import ProgramView from "@/views/ProgramView";
import ProgramViewMemberCompleted from "@/views/ProgramViewMemberCompleted";
import ProgramViewMemberCancel from "@/views/ProgramViewMemberCancel";
import ProgramViewMemberEdit from "@/views/ProgramViewMemberEdit";
import ProgramViewMemberReport from "@/views/ProgramViewMemberReport";
import ProgramViewMemberResult from "@/views/ProgramViewMemberResult";
import WellnessRewardList from "@/views/WellnessRewardList";
import WellnessRewardHistory from "@/views/WellnessRewardHistory";
import OnlineSurvey from "@/views/OnlineSurvey";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import getUserInfoByUserId from "@/data/getUserInfoByUserId";

Vue.use(Router);

let router = new Router({
  mode: "history",

  routes: [
    {
      path: "/dashboard",
      name: "Group",
      component: DashboardByGroup,
      meta: {
        auth: true,
      },
    },
    {
      path: "/group/view/:id/:uid",
      name: "Member View",
      component: MemberView,
      props: true,
      meta: {
        auth: true,
      },
    },
    {
      path: "/group/view/:id",
      name: "Group View",
      component: GroupView,
      props: true,
      meta: {
        auth: true,
      },
    },
    {
      path: "/group/add",
      name: "Add Group",
      component: GroupForm,
      meta: {
        auth: true,
      },
    },
    {
      path: "/group/edit/:id",
      name: "Edit Group",
      component: GroupForm,
      meta: {
        auth: true,
      },
    },
    {
      path: "/login",
      name: "Login Page",
      component: LoginPage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/",
      name: "Landing Page",
      component: LandingPage,
      meta: {
        guest: true,
      },
    },
    {
      path: "/line-callback",
      name: "Line callback",
      component: LineCallback,
      meta: {
        guest: true,
      },
    },
    {
      path: "/challenge",
      name: "Challenge Page",
      component: ChallengePage,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/challenge/:id",
      name: "Challenge Competition Group",
      component: ChallengeGroupList,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/challenge-add",
      name: "New Challenge",
      component: ChallengeForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/challenge-edit/:id",
      name: "Update Challenge",
      component: ChallengeForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/challenge/:id/:group_id",
      name: "Challenge User List",
      component: ChallengeUserList,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/challenge/:id/:group_id/:user_id",
      name: "Challenge Competition Group User Attached",
      component: ChallengeUserDetail,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/challengesummary/:id",
      name: "Group summary",
      component: ChallengeSummary,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/challengeverify/:id",
      name: "Group verify",
      component: ChallengeGroupListVerify,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/user",
      name: "Admin Management",
      component: ChallengeAdminManagement,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/user/add",
      name: "Admin Add",
      component: ChallengeAdminManagementForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: false
      },
    },
    {
      path: "/user/edit/:user_id",
      name: "Admin Update",
      component: ChallengeAdminManagementForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: false
      },
    },
    {
      path: "/healthpoint-level",
      name: "healthpoint-level",
      component: HealthpointLevel,
      meta: {
        auth: true,
      },
    },
    {
      path: "/quiz",
      name: "Quiz List",
      component: QuizManagementList,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/quiz-add",
      name: "Quiz Form Add",
      component: QuizManagementForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/quiz-edit/:id",
      name: "Quiz Form Edit",
      component: QuizManagementForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/online-survey",
      name: "Online Survey",
      component: OnlineSurvey,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/org",
      name: "Organization List",
      component: OrgManagementList,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/org-add",
      name: "Organization Form Add",
      component: OrgManagementForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/org-edit/:id",
      name: "Organization Form Edit",
      component: OrgManagementForm,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/org-coach/:id",
      name: "Organization Coach List",
      component: OrgManagementCoachList,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/org-coach",
      name: "Organization Coach List For Admin",
      component: OrgManagementCoachList,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/program/member-list",
      name: "Program member list",
      component: ProgramViewMemberList,
      meta: {
          auth: true,
          superAdmin: true,
          challengeAdmin: true
      },
    },
    {
      path: "/program/program-list",
      name: "Program List",
      component: ProgramManagementList,
      meta: {
          auth: true,
          superAdmin: true,
          challengeAdmin: true
      },
    },
    {
        path: "/program/program-list/coach/:uid",
        name: "Program List for super admin",
        component: ProgramManagementList,
        meta: {
            auth: true,
            superAdmin: true,
            challengeAdmin: true
        },
    },
    {
      path: "/program/program-list/add",
      name: "Program Form Add",
      component: ProgramManagementForm,
      meta: {
          auth: true,
          superAdmin: true,
          challengeAdmin: true
      },
    },
    {
      path: "/program/program-list/edit/:id/addCoach",
      name: "Program View Member Add coach",
      component: ProgramManagementCoachForm,
      meta: {
          auth: true,
          superAdmin: true,
          challengeAdmin: true
      },
    },
    {
      path: "/program/program-list/edit/:id",
      name: "Program Form Edit",
      component: ProgramManagementForm,
      meta: {
          auth: true,
          superAdmin: true,
          challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id/:uid/end",
      name: "Program View Member Completed",
      component: ProgramViewMemberCompleted,
      props: true,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id/:uid/cancel",
      name: "Program View Member Cancel",
      component: ProgramViewMemberCancel,
      props: true,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id/:uid/edit",
      name: "Program View Member Edit",
      component: ProgramViewMemberEdit,
      props: true,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id/:uid/report/:tab",
      name: "Program View Member Report by mod",
      component: ProgramViewMemberReport,
      props: true,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id/:uid/report",
      name: "Program View Member Report",
      component: ProgramViewMemberReport,
      props: true,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id/:uid/result",
      name: "Program View Member Result",
      component: ProgramViewMemberResult,
      props: true,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/bloodtests/:id/:uid/add",
      name: "Program member bloodtests add",
      component: BloodTestsForm,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/bloodtests/:id/:uid/:docId",
      name: "Program member bloodtests edit",
      component: BloodTestsForm,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/bloodtests/:id/:uid",
      name: "Program member bloodtests list",
      component: BloodTestsList,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/body/:id/:uid/add",
      name: "Program member body add",
      component: BodyForm,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/body/:id/:uid/:docId",
      name: "Program member body edit",
      component: BodyForm,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/body/:id/:uid",
      name: "Program member body list",
      component: BodyList,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id/:uid/:onsite",
      name: "Program member",
      component: ProgramManagementMemberForm,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/view/:id",
      name: "Program View",
      component: ProgramView,
      props: true,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: true
      },
    },
    {
      path: "/program/:mod/user/:id",
      name: "Program user",
      component: ProgramManagementMember,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: false
      },
    },
    {
      path: "/program",
      name: "Program page",
      component: ProgramManagement,
      meta: {
        auth: true,
        superAdmin: false,
        challengeAdmin: false
      },
    },
    {
      path: "/wellness-rewards",
      name: "Rewards",
      component: WellnessRewardList,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
    {
      path: "/wellness-rewards/history",
      name: "Reward History",
      component: WellnessRewardHistory,
      meta: {
        auth: true,
        superAdmin: true,
        challengeAdmin: true
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        (async () => {
          const userInfo = await getUserInfoByUserId(user.uid);
          if( from.name == 'LoginPage' && (userInfo.role == 'challengeAdmin' || userInfo.role == 'superAdmin') ){
            let permissionList = [];
            if( userInfo.permissions != undefined && userInfo.permissions.length ){
              permissionList = userInfo.permissions;
            }
            if( permissionList.includes('accessCoachAdmin') ){
              next({
                  path: '/program'
              });
            }
            else if( permissionList.includes('accessOrgAdmin') ){
              next({
                path: '/org-coach'
              });
            }
            else if( permissionList.includes('accessQuiz') ){
              next({
                path: '/quiz'
              });
            }
            else if( permissionList.includes('accessOnlineSurvey') ){
              next({
                path: '/online-survey'
              });
            }
            else if( permissionList.includes('accessRewardProduct') ){
              next({
                path: '/wellness-rewards'
              });
            }
            else{
              next({
                  path: '/challenge'
              });
            }
          }
          else{
            next();
          }

        })();
        next();
      } else {
        next({
          path: "/",
        });
      }
    });
  } else if (to.matched.some((record) => record.meta.guest)) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next({
          path: "/dashboard",
        });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
